import SiteSearchGroup from '../../../components/search-group'
import Detail from './detail.dialog.vue'
// import Detail from '../submit-manuscripts/confirmation-submission/detail.dialog.vue'
import manuscript from '@/api/manuscript'
import { ARTICLE_STATUS } from '@/utils/dict'
import SendEmail from '../../editorial-office/manuscripts/dialog/send-email.dialog'
import { mapGetters, mapActions } from 'vuex'
import file from '@/api/file'

const columnsSubmit = [
  {
    title: '',
    enTitle: '',
    width: 100,
    dataIndex: 'logo',
    slot: 'img',
  },
  {
    title: '',
    enTitle: 'Manuscript No.',
    width: 120,
    dataIndex: 'code',
  },
  {
    title: '',
    enTitle: 'Article Title',
    width: 250,
    dataIndex: 'title',
    slot: 'omission',
  },
  // {
  //   title: '',
  //   enTitle: 'Current Status',
  //   width: 120,
  //   dataIndex: 'status',
  //   slot: 'status'
  // },
  {
    title: '',
    enTitle: 'Status / Date',
    width: 200,
    dataIndex: 'statusTime',
    slot: 'date',
  },
  {
    title: '',
    enTitle: 'Revision Due Day',
    width: 220,
    dataIndex: 'reviseDueTime',
    slot: 'time',
  },
  {
    title: '',
    enTitle: 'Special Issue',
    width: 250,
    dataIndex: 'special',
    slot: 'special',
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 120,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions',
  },
]
const columnsIncomplete = [
  {
    title: '',
    enTitle: '',
    width: 100,
    dataIndex: 'logo',
    slot: 'img',
  },
  {
    title: '',
    enTitle: 'Manuscript No.',
    width: 120,
    dataIndex: 'code',
  },
  {
    title: '',
    enTitle: 'Article Title',
    width: 250,
    dataIndex: 'title',
    slot: 'omission',
  },
  {
    title: '',
    enTitle: 'Status Date',
    width: 200,
    dataIndex: 'statusTime',
    slot: 'date',
  },
  // {
  //   title: '',
  //   enTitle: 'Revision Due Day',
  //   width: 220,
  //   dataIndex: 'reviseDueTime',
  //   slot: 'time'
  // },
  {
    title: '',
    enTitle: 'Special Issue',
    width: 250,
    dataIndex: 'special',
    slot: 'special',
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 120,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions',
  },
]
const columnsDraft = [
  {
    title: '',
    enTitle: '',
    width: 100,
    dataIndex: 'img',
    slot: 'img',
  },
  {
    title: '',
    enTitle: 'Manuscript No.',
    width: 130,
    dataIndex: 'code',
  },
  {
    title: '',
    enTitle: 'Article Title',
    width: 250,
    dataIndex: 'title',
    slot: 'omission',
  },
  {
    title: '',
    enTitle: 'Status Date',
    width: 200,
    dataIndex: 'statusTime',
    slot: 'date',
  },
  {
    title: '',
    enTitle: 'Special Issue',
    width: 250,
    dataIndex: 'special',
    slot: 'special',
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 200,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions',
  },
]
export default {
  components: {
    SiteSearchGroup,
    Detail,
    SendEmail,
  },
  data() {
    return {
      columns: {
        INCOMPLETE_SUBMISSIONS: columnsIncomplete,
        // DRAFT: columnsDraft,
        UNDER_PROCESSING: columnsSubmit,
        PAPER_ACCEPTED: columnsDraft,
        REJECTED_OR_WITHDRAWN: columnsDraft,
      },
      journalList: [],
      status1: ARTICLE_STATUS,
      dataSource: [],
      params: {
        status: 'UNDER_PROCESSING',
        // journalId: ''
      },
      count: {},
      STATUS: {
        INCOMPLETE_SUBMISSIONS: 'Incomplete Submission',
        UNDER_PROCESSING: 'Under Processing',
        PAPER_ACCEPTED: 'Accepted',
        REJECTED_OR_WITHDRAWN: 'Rejected | Withdrawn',
      },
      emptyText: {
        INCOMPLETE_SUBMISSIONS: 'There is no manuscript which is incomplete.',
        UNDER_PROCESSING: 'There is no manuscript which is under processing .',
        PAPER_ACCEPTED: 'There is no manuscript which has been accepted.',
        REJECTED_OR_WITHDRAWN:
          'There is no manuscript which has been rejected or withdrawn. ',
      },
      pagination: {
        total: 0,
        size: 50,
        current: 1,
        sizeChange: true,
        onPageChange: this.getList,
        pageSizeOptions: [5, 10, 30, 50, 100], // 每页数量选项
        showQuickJumper: true,
      },
      isVisable: false,
      showSendEmail: false,
      editVal: {},
      inputData: {},
    }
  },
  computed: {
    ...mapGetters({
      domain: 'getDomain',
      user: 'getUser',
    }),
  },
  mounted() {
    this.getJournalList()
  },
  methods: {
    ...mapActions(['updateDomain']),
    async getDomain() {
      const domain = await file.domain()
      this.updateDomain(domain)
    },
    async getList(page = 1) {
      const data = Object.assign(this.params, {
        pageIndex: page,
        pageSize: this.pagination.size,
      })
      const result = await manuscript.author(data)
      this.dataSource = result.list
      this.pagination = Object.assign(this.pagination, {
        total: result.total,
        size: result.pageSize,
        current: result.pageIndex,
      })
      this.getCount()
    },
    async getCount() {
      const { status, ...data } = this.params
      const arr = await manuscript.authorCount(data)
      this.count = arr
    },
    async getJournalList() {
      // this.journalList = await journal.getAll({ released: true })
      // const flag = this.journalList.some(item => {
      //   if (item.id === localStorage.getItem('opjournalId')) {
      //     this.params.journalId = item.id
      //     return true
      //   }
      // })
      // if (!flag) {
      //   this.params.journalId = this.journalList[0] && this.journalList[0].id
      //   localStorage.setItem('opjournalId', this.params.journalId)
      // }
      this.getList()
    },
    handleClear() {
      this.params.keyword = ''
      // this.params.journalId = ''
      this.getList()
    },
    submit() {
      this.$router.push('/author/submit-manuscripts/step1')
    },
    changeStatus(val) {
      this.params.status = val
      this.getList()
    },
    // 编辑
    edit(val) {
      this.$router.push(
        `/author/submit-manuscripts/step${val.step + 1}?id=${val.id}`
      )
    },
    // 删除
    del(val) {
      this.$confirm({
        title: 'Are you sure you want to delete this manuscript?',
        content:
          'Please be aware that once this manuscript is deleted, it will never be able to be recovered.',
        type: 'danger',
        icon: 'iconDelete',
      }).then(async () => {
        await manuscript.del(val.id)
        this.$message.success({
          title: 'Success',
          content: 'This manuscript has been deleted!',
        })
        this.getList()
      })
    },
    // 查看详情
    detail(val) {
      this.isVisable = true
      this.inputData = val
    },
    // 申请延时
    sendEmail(val) {
      this.showSendEmail = true
      this.inputData = {
        manuscriptId: val.id,
        sign: val.sign,
        journalId: val.journalId,
      }
    },
    // 修订
    revision(val) {
      this.$router.push(
        `/author/submitted-manuscripts/author-revised?id=${val.id}&sign=${val.sign}`
      )
    },
    // 重新提交
    recommit(val) {
      this.$router.push(`/author/submit-manuscripts/step1?id=${val.id}`)
    },
    // 查看决策
    decision(val) {
      this.$router.push(
        `/author/submitted-manuscripts/author-report?id=${val.id}&sign=${val.sign}`
      )
    },
    cancel() {
      this.isVisable = false
      this.showSendEmail = false
    },
    changeJournal(val) {
      this.getList()
      // localStorage.setItem('opjournalId', val)
    },
  },
}
